import React, { useEffect, useState } from 'react';
import DashboardIcon from '@mui/icons-material/Dashboard';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import DesktopMacIcon from '@mui/icons-material/DesktopMac';
import ListIcon from '@mui/icons-material/List';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import SettingsIcon from '@mui/icons-material/Settings';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './sidebar.css';
// import { ReactComponent as ScreenIcon } from "../../Assets/images/screenIcon.svg";
// import { ReactComponent as LogoutIcon } from "../../Assets/images/logoutIcon.svg";
import { logout } from '../../Redux/Actions/userAction';
import {useDispatch} from 'react-redux';
import { Button } from '@mui/material';
import {makeStyles} from '@material-ui/core';
import { LogoutOutlined } from '@mui/icons-material';
import { AiFillAndroid } from 'react-icons/ai';
import { Layers } from 'lucide-react';
import BarChartIcon from '@mui/icons-material/BarChart';
import InsightsIcon from '@mui/icons-material/Insights';
import ExtensionIcon from '@mui/icons-material/Extension';
import QueryStatsIcon from '@mui/icons-material/QueryStats';
import { tr } from "../../i18n";
import { api } from '../../api/api';
import { useContextUserId } from '../../hooks/useSupportContext';
import { isSuperAdmin, isSupport } from '../../utils/accessControl';

// Is the statistics page on for this account? Asked once per context user, not per page.
const kpiVisibleCache = new Map();
function useKpiVisible(user) {
    const contextUserId = useContextUserId();
    const staff = isSuperAdmin(user) || isSupport(user);
    const [visible, setVisible] = useState(staff || kpiVisibleCache.get(contextUserId) === true);
    useEffect(() => {
        if (staff) { setVisible(true); return; }
        if (!contextUserId) return;
        if (kpiVisibleCache.has(contextUserId)) { setVisible(kpiVisibleCache.get(contextUserId)); return; }
        let active = true;
        api.get(`/kpi/config/${contextUserId}`)
            .then((r) => { kpiVisibleCache.set(contextUserId, Boolean(r.data?.visible)); if (active) setVisible(Boolean(r.data?.visible)); })
            .catch(() => {});
        return () => { active = false; };
    }, [staff, contextUserId]);
    return visible;
}
const useStyle=makeStyles((theme)=>{
    return {
      text:{
          [theme.breakpoints.down('sm')]:{
            //   display:'none'
          }
      },
      sibarContainerMobile:{
        [theme.breakpoints.down('sm')]:{
            // width:'70px !important',
        }
    },
    sidebarUpperSecMobile:{
       
        [theme.breakpoints.down('sm')]:{
            display:'flex !important',
            justifyContent:'center !important',
            alignItems:'center !important',
            // width:'70px !important',
            // height:'20vh',
            '& img':{
                // width:'80px !important',
                // height:'80px !important'
            }
        }
    }
    }
})
function Sidebar({ user }) {
    const location=useLocation();
    const classes=useStyle();
    const [gridView, setGridView] = useState(true)
    const dispatch=useDispatch();
    const navigate=useNavigate();
    const kpiVisible=useKpiVisible(user);
const logoutHandler=()=>{
    dispatch(logout())
 return navigate('/login')
}
// console.log(location.pathname)
    return (
        <>
            <div className={`sidebar-container ${classes.sibarContainerMobile}`}>
                <div className={`sidebar-upper-sec ${classes.sidebarUpperSecMobile}`}>
                    <img src='/images/notiz-logo.png' style={{height:'100%',width:'100%'}} alt={tr("NOTIZ Logo")} />
                </div>
                <div className="sidebar-middle-sec">
                    <div className="side-bar-box">
                        <div className="links" style={{background:location.pathname==='/' ? "var(--primary-color-rgba)" : ''}}>
                            <div className='link-icon'>
                                <DashboardIcon className={location.pathname=='/' ? 'link-active-a-color':'link-a-color'} />
                            </div>
                            <Link
                            style={{color:location.pathname==='/' ? "var(--primary-forecolor)" : ''}}
                             to='/'>{tr("Dashboard")}</Link>
                        </div>
                            <div className="links" style={{background:location.pathname==='/screen' ? "var(--primary-color-rgba)" : ''}}>
                                <div className='link-icon'>
                                    <DesktopMacIcon className={location.pathname=='/screen' ? 'link-active-a-color':'link-a-color'} />
                                </div>
                                <Link  
                                style={{color:location.pathname==='/screen' ? "var(--primary-forecolor)" : ''}}
                                 to="/screen">{tr("Screen Setting")}</Link>
                            </div>
    
                            <div className="links" style={{background:location.pathname==='/playlist' ? "var(--primary-color-rgba)" : ''}}>
                                <div className='link-icon'>
                                    <ListIcon className={location.pathname=='/playlist' ? 'link-active-a-color':'link-a-color'} />
                                </div>
                                <Link  
                                style={{color:location.pathname==='/playlist' ? "var(--primary-forecolor)" : ''}}
                                 to="/playlist">{tr("Playlists")}</Link>
                            </div>
                            <div className="links" style={{background:location.pathname==='/layout' || location.pathname==='/design-editor' ? "var(--primary-color-rgba)" : ''}}>
                                <div className='link-icon'>
                                    <Layers className={location.pathname==='/layout' || location.pathname==='/design-editor' ? 'link-active-a-color':'link-a-color'} />
                                </div>
                                <Link  
                                style={{color:location.pathname==='/layout' || location.pathname==='/design-editor' ? "var(--primary-forecolor)" : ''}}
                                 to="/layout">{tr("Layout")}</Link>
                            </div>
                        {kpiVisible && <div className="links" style={{background:location.pathname==='/statistics' ? "var(--primary-color-rgba)" : ''}}>
                            <div className='link-icon'>
                                <InsightsIcon className={location.pathname==='/statistics' ? 'link-active-a-color':'link-a-color'} />
                            </div>
                            <Link
                            style={{color:location.pathname==='/statistics' ? "var(--primary-forecolor)" : ''}}
                             to="/statistics">{tr("Statistics")}</Link>
                        </div>}
                        <div className="links" style={{background:location.pathname==='/integrations' ? "var(--primary-color-rgba)" : ''}}>
                            <div className='link-icon'>
                                <ExtensionIcon className={location.pathname==='/integrations' ? 'link-active-a-color':'link-a-color'} />
                            </div>
                            <Link
                            style={{color:location.pathname==='/integrations' ? "var(--primary-forecolor)" : ''}}
                             to="/integrations">{tr("Integrations (beta)")}</Link>
                        </div>
                        <div className="links" style={{background:location.pathname==='/content' ? "var(--primary-color-rgba)" : ''}}>
                            <div className='link-icon'>
                                <TextSnippetIcon className={location.pathname=='/content' ? 'link-active-a-color':'link-a-color'} />
                            </div>
                            <Link style={{
                                color:location.pathname==='/content' ? "var(--primary-forecolor)" : '',
                            }}  to="/content">{tr("Content")}</Link>
                        </div>
                        {
                            (user?.role === 'admin' || user?.role === 'organization' || user?.role === 'super-admin') &&
                            <>
                            <div className="links" style={{background:location.pathname==='/user' ? "var(--primary-color-rgba)" : ''}}>
                                <div className='link-icon'>
                                    <PersonAddIcon className={location.pathname=='/user' ? 'link-active-a-color':'link-a-color'} />
                                </div>
                                <Link  
                                style={{color:location.pathname==='/user' ? "var(--primary-forecolor)" : ''}}
                                 to="/user">{tr("User")}</Link>
                            </div>
                            </>
                        }

                        {
                            user?.role=='super-admin' &&   <div className="links" style={{background:location.pathname==='/apk' ? "var(--primary-color-rgba)" : ''}}>
                                <div className='link-icon'>
                                    <AiFillAndroid size={22} className={location.pathname=='/apk' ? 'link-active-a-color':'link-a-color'} />
                                </div>
                                <Link  
                                style={{color:location.pathname==='/apk' ? "var(--primary-forecolor)" : ''}}
                                 to="/apk">{tr("Apk")}</Link>
                            </div>
                        }

                        {
                            user?.role=='super-admin' &&   <div className="links" style={{background:location.pathname==='/bandwidth' ? "var(--primary-color-rgba)" : ''}}>
                                <div className='link-icon'>
                                    <BarChartIcon className={location.pathname=='/bandwidth' ? 'link-active-a-color':'link-a-color'} />
                                </div>
                                <Link
                                style={{color:location.pathname==='/bandwidth' ? "var(--primary-forecolor)" : ''}}
                                 to="/bandwidth">{tr("Bandwidth")}</Link>
                            </div>
                        }

                        {
                            user?.role=='super-admin' &&   <div className="links" style={{background:location.pathname==='/activity' ? "var(--primary-color-rgba)" : ''}}>
                                <div className='link-icon'>
                                    <QueryStatsIcon className={location.pathname=='/activity' ? 'link-active-a-color':'link-a-color'} />
                                </div>
                                <Link
                                style={{color:location.pathname==='/activity' ? "var(--primary-forecolor)" : ''}}
                                 to="/activity">{tr("Customer activity")}</Link>
                            </div>
                        }

                        <div className="links">
                            <div className='link-icon'>
                                <LogoutOutlined className={'link-a-color'} />
                            </div>
                            <button style={{
                                border:'none',
                                outline:'none',
                                background: (!gridView ? '#F3F0FF' : 'white'),
                                cursor:'pointer',
                                color: '#B8B8B8'

                            }} onClick={logoutHandler}>{tr("Logout")}</button>
                        </div>
                    </div>
                </div>
                {/* <div className="sidebar-bottom-sec">
                    <div className="settings">
                        <SettingsIcon style={{ color: 'white' }} />
                    </div>
                </div> */}
            </div>
        </>
    )
}

export default Sidebar